/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { setVideoAds } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import VideoAds from 'pages/dashboard/embeds/management/ads/videoads/videoads';



/* ========== ~~~~~~~~~~ PAGE : ADs : VIDEO ADs : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }) => ({
    videoAdsStatus: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.ads.video
});

// map actions
const mapDispatchToProps = dispatch => ({
	setVideoAds: (device, value) => dispatch(setVideoAds(device, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoAds);